import Modal from '../components/modal'
import * as captcha from '../api/catpcha'
import { action } from '../utils/requests'
import { sendEmail } from '../api/email'

export default {
  name: 'FormContact',
  components: {
    Modal,
  },
  data() {
    return {
      fields: {
        name: '',
        surname: '',
        company: '',
        phone: '',
        email: '',
        interest: [],
        media_analysis_option: '',
        remarks: '',
      },
      captcha: '',
      captcha_image: '',
      success: false,
      submiting: false,
    }
  },
  mounted() {
    this.generateCaptcha()
  },
  methods: {
    submitForm() {
      if (this.submiting) {
        return
      }

      this.submiting = true

      this.validateCaptcha().then(success => {
        if (success) {
          action('save_form', {
            fields: this.fields,
            form: 'contact_form',
          }).then(() => {
            // sendEmail('rafael.almeida@grandesplanos.com', "Argus Contact", 'email-contact-form.twig', this.fields);
            if (window.location.hostname.split('.').pop() == 'ch') {
              sendEmail('mail@argusdatainsights.ch', 'Argus Contact', 'email-contact-form.twig', this.fields)
            } else {
              sendEmail('info@argusdatainsights.de', 'Argus Contact', 'email-contact-form.twig', this.fields)
            }

            this.resetForm()
            this.success = true
            this.submiting = false
          })
        } else {
          this.generateCaptcha()
          this.submiting = false
        }
      })
    },

    validateCaptcha() {
      return captcha
        .validate(captcha.prefix(), this.captcha)
        .then(res => res.status)
    },

    resetForm() {
      this.fields = {
        name: '',
        surname: '',
        company: '',
        phone: '',
        email: '',
        interest: [],
        media_analysis_option: '',
        remarks: '',
      }
      this.success = false
      this.generateCaptcha()
    },
    generateCaptcha() {
      this.captcha = ''
      captcha.create('#708190', '#fff').then(res => {
        this.captcha_image = res.image
      })
    },
  },
}
